import axiosInstance from "../config/axiosInterceptor";

export async function getProjects() {
  return await axiosInstance.get("/api/Project");
}

export async function getProjectByCode(code) {
  return await axiosInstance.get(`/api/Project/GetByCode/${code}`);
}

export async function getProjectDetailStatuses() {
  try {
    const projectCode = localStorage.getItem("projectCode");
    const response = await axiosInstance.get("/api/Project");

    const data = response?.data || response || [];
    const filtered = Array.isArray(data)
      ? data.filter((item) => String(item?.code) === String(projectCode))
      : [];

    const project = filtered[0];
    if (!project || !project.defaultStatusObjects) return [];

    try {
      const statusObjects = JSON.parse(project.defaultStatusObjects);
      const raw = statusObjects?.detailStatuses || [];
      if (!Array.isArray(raw)) return [];
      return raw
        .filter((v) => typeof v === "number" || typeof v === "string")
        .map((v) => String(v));
    } catch (err) {
      console.error("Error parsing defaultStatusObjects:", err);
      return [];
    }
  } catch (error) {
    console.error("Error fetching project detail statuses:", error);
    return [];
  }
}
